import * as React from 'react';
import AnalizeProjectsComponent from 'src/modules/how-to-invest/partials/AnalizeProjects.component';
import InvestSafelyComponent from 'src/modules/how-to-invest/partials/InvestSafely.component';
import FollowUpComponent from 'src/modules/how-to-invest/partials/FollowUp.component';
import SelectionCriteriaSectionComponent from 'src/modules/how-to-invest/partials/SelectionCriteriaSection';
import ProjectListContainer from '../projects/ProjectList.container';
import SyndicationSectionComponent from 'src/modules/how-to-invest/partials/SyndicationSection.component';
import TransparentFeesSectionComponent from 'src/modules/how-to-invest/partials/TransparentFeesSection.component';
import './partials/HowToInvest.css';

interface Props {
  register: () => void;
  isLogged?: boolean;
}

class HowToInvestComponent extends React.PureComponent<Props> {
  private activeTab: string = 'analize';

  public render(): React.ReactNode {
    return (
      <section>
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-md-10">
                <h1 className="bold-title">
                  Cómo invertir a través de The Crowd Angel
                </h1>
                <div className="gap-20"/>
              </div>
              <div className="col-md-2">
                <p className="breadcrumb text-right">
                  Inicio > cómo invertir
                </p>
              </div>
            </div>
            <div className="gap-10"/>
            <div className="row">
              <div className="col-sm-12">
                <h3 style={{fontSize: '22px'}}>
                  <strong>Inversores</strong>
                </h3>
              </div>
            </div>
            <div className="gap-20"/>
            <div className="row">
              <div className="col-sm-6">
                <p>
                  Nuestra misión es democratizar la inversión en capital riesgo, canalizando de manera rentable una
                  parte
                  de los ahorros de nuestros inversores hacia startups de alto potencial, que además de generar
                  rentabilidades para nuestros inversores, generen puestos de trabajo y actividad económica productiva
                  en
                  el país.
                </p>
                <div className="gap-20"/>
                <p>
                  Para ello, The Crowd Angel aúna la viralidad y la flexibilidad del crowdfunding con las mejores
                  prácticas del Capital Riesgo, con el objetivo de simplificar el proceso de inversión en startups.
                  Desde
                  un mínimo de 3.000 € por inversión, puedes construirte una cartera diversificada de startups de alto
                  potencial.
                </p>
                <div className="gap-20"/>
                <p>
                  Hemos reunido a profesionales de máxima experiencia en consultoría e inversión en startups para
                  diseñar
                  el proceso de estructuración de las operaciones, los acuerdos sociales, y los contratos que regirán la
                  inversión y la relación entre Crowd Angels, Emprendedores y las Empresas.
                </p>
              </div>
              <div className="col-sm-6 text-center">
                <img
                  height="330px"
                  alt="mision"
                  src="/img/01_mision.jpg"
                />
              </div>
            </div>
            <div className="gap-30"/>
            <div className="row">
              <div className="col-sm-12">
                <p>
                  <strong style={{fontSize: '16px'}}>
                    Para facilitar el acceso a oportunidades de inversión, hemos diseñado un proceso de inversión
                    simple que se resume en tres pasos:
                  </strong>
                </p>
              </div>

            </div>
            <div className="gap-20"/>
            <div className="row">
              <div style={{cursor: 'pointer'}} className="col-xs-4 padding-r-0">
                <div onClick={() => this.changeTab('analize')}>
                  <div className={'tab ' + (this.activeTab === 'analize' ? 'tab-active' : '')}>
                    <span className="tab-icon projects hidden-xs"/>
                    <h4>
                      <strong>1. <span>Analiza las<br/>operaciones abiertas</span></strong>
                    </h4>
                  </div>
                </div>
              </div>
              <div style={{cursor: 'pointer'}} className="col-xs-4 padding-l-r-0">
                <div onClick={() => this.changeTab('security')}>
                  <div className={'tab ' + (this.activeTab === 'security' ? 'tab-active' : '')}>
                    <span className="tab-icon guard hidden-xs"/>
                    <h4>
                      <strong>2. <span>Invierte<br/>de forma segura</span></strong>
                    </h4>
                  </div>
                </div>
              </div>
              <div style={{cursor: 'pointer'}} className="col-xs-4 padding-l-0">
                <div onClick={() => this.changeTab('followUp')}>
                  <div className={'tab ' + (this.activeTab === 'followUp' ? 'tab-active' : '')}>
                    <span className="tab-icon analytics hidden-xs"/>
                    <h4>
                      <strong>3. <span>Realiza<br/>el seguimiento</span></strong>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 padding-l-r-0">
                <div className="tab-shadow-control">
                  {
                    (this.activeTab === 'analize') ?
                      <AnalizeProjectsComponent
                        register={this.props.register}
                        isLogged={this.props.isLogged}
                      /> : (
                        this.activeTab === 'security' ?
                          <InvestSafelyComponent
                            register={this.props.register}
                            isLogged={this.props.isLogged}
                          /> :
                          <FollowUpComponent
                            register={this.props.register}
                            isLogged={this.props.isLogged}
                          />
                      )
                  }
                </div>

              </div>
            </div>
          </div>
          <SelectionCriteriaSectionComponent/>

          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="bold-subtitle">Nuestro portfolio</h3>
                <div className="gap-20"/>
                <ProjectListContainer
                  status="closed"
                  limit={4}
                  listKey="homeClosedProjects"
                  isSimple={true}
                  carousel={true}
                  numberOfItems={3}
                />
              </div>
            </div>
          </div>

          <SyndicationSectionComponent/>
          <TransparentFeesSectionComponent
            register={this.props.register}
            isLogged={this.props.isLogged}
          />

        </div>
      </section>
    );
  }

  private changeTab(activeTab: string): void {
    this.activeTab = activeTab;
    this.setState({
      activeTab: this.activeTab
    });
  }
}

export default HowToInvestComponent;



// WEBPACK FOOTER //
// ./src/modules/how-to-invest/HowToInvest.component.tsx